import './AdminDashboard.css';
import { useNavigate } from 'react-router-dom';

function AdminDashboard() {
    const navigate = useNavigate();

    const adminTiles = [
        {
            id: 'create-author',
            title: 'Vytvořit autora',
            description: 'Přidat nového autora do databáze',
            icon: '👤',
            path: '/admin/create-author',
            color: '#e94560'
        },
        {
            id: 'manage-authors',
            title: 'Spravovat autory',
            description: 'Upravit nebo smazat existující autory',
            icon: '📝',
            path: '/admin/manage-authors',
            color: '#4CAF50'
        },
        {
            id: 'create-book',
            title: 'Vytvořit knihu',
            description: 'Přidat novou knihu do databáze',
            icon: '📚',
            path: '/admin/create-book',
            color: '#2196F3'
        },
        {
            id: 'manage-books',
            title: 'Spravovat knihy',
            description: 'Upravit nebo smazat existující knihy',
            icon: '📖',
            path: '/admin/manage-books',
            color: '#FF9800'
        },
        {
            id: 'create-question',
            title: 'Vytvořit otázku',
            description: 'Přidat novou otázku do databáze',
            icon: '❓',
            path: '/admin/create-question',
            color: '#9C27B0'
        },
        {
            id: 'manage-questions',
            title: 'Spravovat otázky',
            description: 'Upravit nebo smazat existující otázky',
            icon: '📝',
            path: '/admin/manage-questions',
            color: '#00BCD4'
        }
    ];

    const handleTileClick = (tile) => {
        if (!tile.disabled) {
            navigate(tile.path);
        }
    };

    return (
        <div className="admin-dashboard-page">
            <div className="admin-dashboard-container">
                <h1 className="page-title">Administrace</h1>
                <p className="page-subtitle">Vyberte akci, kterou chcete provést</p>

                <div className="admin-tiles-grid">
                    {adminTiles.map(tile => (
                        <div
                            key={tile.id}
                            className={`admin-tile ${tile.disabled ? 'disabled' : ''}`}
                            onClick={() => handleTileClick(tile)}
                            style={{
                                '--tile-color': tile.color
                            }}
                        >
                            <div className="tile-icon">{tile.icon}</div>
                            <h2 className="tile-title">{tile.title}</h2>
                            <p className="tile-description">{tile.description}</p>
                            {tile.disabled && (
                                <span className="tile-badge">Brzy dostupné</span>
                            )}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default AdminDashboard;
